import { useState, useEffect } from "react";

/**
 * Like `useState` but the value is also updated any time the passed value changes.
 */
export function useFreshState(value) {
  const [local, setLocal] = useState(value);

  // Update local when passed value changes.
  useEffect(() => {
    setLocal(value);
  }, [value]);

  return [local, setLocal];
}
